<template>
  <view class="container">
   <video autoplay id="videoElement" controls></video>


   <u-empty style="padding-top: 300px;" v-if="state.emptylive" text="远程连接失败" mode="data">
			<u-button @click="handleUpdate" size="small" type="primary" :style="{marginTop:10+'px'}" text="点击重新获取">
			</u-button>
		</u-empty>
  </view>
</template>

<script>
import {
  queryMediaVideoSubscribe,
  queryMediaVideHeartbeat,
} from "@/api/user";
import { defineComponent, onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import Hls from 'hls.js';
export default defineComponent({
  name: "GaoBuMonitorDetail",

  components: {
  },

  setup() {
    const route = useRoute();
    const router = useRouter();

    const state = reactive({
      liveUrl: "",
      serialNo: "",
      title: "学校实况",
      emptylive: false
    });

    const player = ref(null)
    const hls = ref(null)
    const retryCount = ref(0)
    const MAX_RETRIES = 3

    const interval = ref(null)
    const visibilityHandler = ref(null)

    const videoElement = ref(null)

    onMounted(() => {
      state.serialNo = route?.query?.serialNo;
      state.title = route?.query?.title ?? "学校实况";
      liveMediaVideoSubscribeStream();

      visibilityHandler.value = () => {
        if (document.hidden) {
          videoElement.value = null
          if (interval.value) {
            clearInterval(interval.value)
            interval.value = null
          }
        } else {
          liveMediaVideoSubscribeStream()
        }
      }
      document.addEventListener('visibilitychange', visibilityHandler.value)
    });
    
    onBeforeUnmount(() => {
      videoElement.value = null
      if(interval.value) {
        clearInterval(interval.value)
        interval.value = null
      }
      // Clean up HLS player
      if (hls.value) {
        hls.value.destroy()
        hls.value = null
      }
      if (player.value) {
        player.value.destroy()
        player.value = null
      }
      // Remove visibility change event listener
      if (visibilityHandler.value) {
        document.removeEventListener('visibilitychange', visibilityHandler.value)
        visibilityHandler.value = null
      }
    })

    const queryHeartbeat = () => {
      queryMediaVideHeartbeat({
        snNum: state.serialNo,
      }).then((res) => {
        console.log("心跳======", res);
      });
    }

    const handleUpdate = () => {
      liveMediaVideoSubscribeStream();
    }

    const liveMediaVideoSubscribeStream = () => {
      state.emptylive = false

      queryMediaVideoSubscribe({
        snNum: state.serialNo,
      }).then((res) => {
        console.log("订阅======", res);
        if (res.code === "00") {
          state.liveUrl = res?.data?.streamUrl;
          playLive();
          
          if(interval.value) {
            clearInterval(interval.value)
            interval.value = null
          }

          interval.value = setInterval(() => {
            queryHeartbeat()
          }, 10000)
          
        } else {
          state.liveUrl = "";
          state.emptylive = true
        }
      }).catch(() => {
        state.emptylive = true
      }).finally(() => {
        
      });
    };

    const playLive = () => {
      videoElement.value = document.getElementById('videoElement');
      console.log('=====',videoElement.value)
      const splitRul = state.liveUrl.split('/');
      if (Hls.isSupported()) {
        console.log('================================Hls')
        if (player.value) {
          player.value.destroy();
        }
        if (hls.value) {
          hls.value.destroy();
        }
        const newHls = new Hls();
        hls.value = newHls;
        player.value = newHls;
        
        // Add error handling
        newHls.on(Hls.Events.ERROR, function(event, data) {
          if (data.fatal) {
            switch(data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.log('Network error, retrying...');
                if (retryCount.value < MAX_RETRIES) {
                  retryCount.value++;
                  console.log(`Retry attempt ${retryCount.value} of ${MAX_RETRIES}`);
                  setTimeout(() => {
                    playLive();
                  }, 1000);
                } else {
                  console.log('Maximum retry attempts reached, stopping player');
                  state.emptylive = true;
                  newHls.destroy();
                  retryCount.value = 0;
                }
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log('Media error, trying to recover...');
                newHls.recoverMediaError();
                break;
              default:
                console.log('Fatal error, stopping player');
                newHls.destroy();
                break;
            }
          }
        });

        newHls.loadSource(`https://www.ubetterplus.com/hls/${splitRul[splitRul.length - 1]}.m3u8`);
        newHls.attachMedia(videoElement.value);
        newHls.on(Hls.Events.MANIFEST_PARSED, function() {
          console.log('================================Hls.Events.MANIFEST_PARSED')
          retryCount.value = 0;
          videoElement.value.play().catch(error => {
            console.log('Video play error:', error);
          });
        });
      } else if (videoElement.value.canPlayType('application/vnd.apple.mpegurl')) {
        console.log('================================video')
        videoElement.value.src = `https://www.ubetterplus.com/hls/${splitRul[splitRul.length - 1]}.m3u8`;
        videoElement.value.addEventListener('loadedmetadata', function() {
          console.log('加载完成>>>loadedmetadata')
          videoElement.value.play().catch(error => {
            console.log('Video play error:', error);
          });
        });
      }
    };

    return {
      state,
      handleUpdate
    };
  },
});
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
}

#videoElement {
  width: 100%;
}
</style>